import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useT } from '../i18n/LocaleContext';
import LanguageToggle from '../components/ui/LanguageToggle';

export default function LoginPage() {
  const t = useT();
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('admin');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login({ username, password });
      toast.success(t('auth.logged_in', { name: `${user.firstName} ${user.lastName}` }));
      const dest = location.state?.from?.pathname || '/dashboard';
      navigate(dest, { replace: true });
    } catch (err) {
      const message = err.code === 'fill_credentials' ? t('auth.fill_credentials') : t('auth.invalid_credentials');
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-lang">
        <LanguageToggle />
      </div>
      <div className="login-card">
        <span className="login-cross">✝</span>
        <div className="login-title">{t('app.name')}</div>
        <div className="login-subtitle">{t('app.subtitle')}</div>
        <div className="login-sep">
          <span className="login-sep-cross">✦</span>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <div className="login-field">
            <label htmlFor="login-username">{t('auth.username')}</label>
            <input
              id="login-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('auth.username_placeholder')}
              disabled={loading}
              autoComplete="username"
            />
          </div>
          <div className="login-field">
            <label htmlFor="login-password">{t('auth.password')}</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('auth.password_placeholder')}
              disabled={loading}
              autoComplete="current-password"
            />
          </div>
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? t('auth.signing_in') : `${t('auth.sign_in')} ✝`}
          </button>
        </form>

        <div className="login-verse">{t('auth.verse')}</div>
      </div>
    </div>
  );
}
